document.addEventListener('click', function(e) {
  var a = e.target.closest('a[data-ga-cta="dtf-link"]');
  if (!a || typeof gtag === 'undefined') return;
  var href = a.getAttribute('href') || '';
  var m = href.match(/\/products\/([^?#/]+)/);
  gtag('event', 'dtf_cta_click', {
    cta_location: a.getAttribute('data-ga-location') || '',
    cta_label: a.getAttribute('data-ga-label') || (a.textContent || '').trim(),
    cta_destination: m ? m[1] : href
  });
});

document.addEventListener('click', function(e) {
  var a = e.target.closest('a[data-ga-cta="patches-link"]');
  if (!a || typeof gtag === 'undefined') return;
  gtag('event', 'patches_cta_click', {
    cta_location: a.getAttribute('data-ga-location') || '',
    cta_label: a.getAttribute('data-ga-label') || (a.textContent || '').trim(),
    cta_destination: a.getAttribute('href') || '',
    environment: window.Shopify && window.Shopify.theme && window.Shopify.theme.role === "main" ? "production" : "staging"
  });
});

document.addEventListener('click', function(e) {
  var a = e.target.closest('a[data-ga-cta="dtftransfers-link"]');
  if (!a || typeof gtag === 'undefined') return;
  gtag('event', 'dtftransfers_cta_click', {
    cta_location: a.getAttribute('data-ga-location') || '',
    cta_label: a.getAttribute('data-ga-label') || (a.textContent || '').trim(),
    cta_destination: a.getAttribute('href') || '',
    environment: window.Shopify && window.Shopify.theme && window.Shopify.theme.role === "main" ? "production" : "staging"
  });
});

// Mega nav links (desktop menu + mobile drawer). Attributes come from snippets/nav-ga.liquid.
// The two blanks collection templates already send blanks_nav_click for these links
// (blanks-collection-tracking.js), so this one stands down there: one event per click,
// and the click map adds both events onto the same link.
document.addEventListener('click', function(e) {
  var a = e.target.closest('a[data-ga-cta="nav-link"]');
  if (!a || typeof gtag === 'undefined') return;
  var b = document.body.classList;
  if (b.contains('template-collection-blanks-home') || b.contains('template-collection-blanks-collection')) return;
  gtag('event', 'mega_nav_click', {
    cta_location: a.getAttribute('data-ga-location') || '',
    cta_label: a.getAttribute('data-ga-label') || (a.textContent || '').trim(),
    cta_destination: a.getAttribute('href') || '',
    environment: window.Shopify && window.Shopify.theme && window.Shopify.theme.role === "main" ? "production" : "staging"
  });
});

// Links inside Customizer richtext (e.g. the homepage FAQ answers) can't carry their own
// attributes. Their wrapper carries data-ga-location + data-ga-prefix, and an untagged same-site
// link inside it sends mega_nav_click labelled "<prefix> > <link text>" (cut to 100, like
// snippets/nav-ga.liquid). Links with data-ga-cta never get here, so their events are unchanged.
document.addEventListener('click', function(e) {
  var a = e.target.closest('a[href]');
  if (!a || a.hasAttribute('data-ga-cta') || typeof gtag === 'undefined') return;
  var w = a.closest('[data-ga-prefix]');
  if (!w) return;
  var href = a.getAttribute('href') || '';
  if (!href || /^(javascript:|#)/i.test(href)) return;
  if (href.indexOf('://') > -1 && href.indexOf(location.hostname.replace(/^www\./, '')) < 0) return; // off-site: GA4's outbound click counts it
  var b = document.body.classList;
  if (b.contains('template-collection-blanks-home') || b.contains('template-collection-blanks-collection')) return;
  gtag('event', 'mega_nav_click', {
    cta_location: w.getAttribute('data-ga-location') || '',
    cta_label: (w.getAttribute('data-ga-prefix') + ' > ' + (a.textContent || '').replace(/\s+/g, ' ').trim()).slice(0, 100),
    cta_destination: href,
    environment: window.Shopify && window.Shopify.theme && window.Shopify.theme.role === "main" ? "production" : "staging"
  });
});

// Brand tabs strip (Ninja Transfers + Ninja Blanks tabs) and their hover panels.
// Attributes come from snippets/nav-ga.liquid with k: 'brand-tab'. No blanks stand-down:
// blanks_nav_click does not cover the strip or the panels.
document.addEventListener('click', function(e) {
  var a = e.target.closest('a[data-ga-cta="brand-tab"]');
  if (!a || typeof gtag === 'undefined') return;
  gtag('event', 'brand_tab_click', {
    cta_label: a.getAttribute('data-ga-label') || '',
    cta_location: a.getAttribute('data-ga-location') || '',
    cta_destination: a.getAttribute('href') || ''
  });
});
